import { X_SEARCH_PARAMS } from '@/constants/headers';
import { safeJsonParse } from '@/modules/storage/helpers';

const headers = import('next/headers');

export async function SERVERSIDE_getSearchParams(): Promise<
  Record<string, string>
> {
  const headersFunction = await headers;
  return safeJsonParse(
    decodeURIComponent(
      (await headersFunction.headers()).get(X_SEARCH_PARAMS) as string
    ),
    {}
  );
}
